import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import AppLayout from './AppLayout';
import RequireAuth from './components/RequireAuth';
import { isAuthenticated } from './auth/storage';

// Landing pública (porta de entrada)
import Landing from './pages/Landing';

// Conta (público)
import Login from './pages/Login';
import RegistrarUser from './pages/RegistrarUser';
import RecuperarAcesso from './pages/RecuperarAcesso';
import EsqueciSenha from './pages/EsqueciSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import RecuperarConta from './pages/RecuperarConta';
import ConfirmarRecuperarConta from './pages/RecuperarConta/Confirmar';
import ConfirmarEmail from './pages/ConfirmarEmail';
import DescadastrarEmail from './pages/DescadastrarEmail';
import NotFound from './pages/NotFound';

// Validador público da carteirinha (aberto pelo QR Code impresso/digital).
import ValidadorUEB from './Page/ValidadorUEB';

// Portal do estudante (privado)
import Dashboard from './pages/Dashboard';
import Produtos from './pages/Produtos';
import MinhaCarteirinha from './pages/MinhaCarteirinha';
import HistoricoPagamentos from './pages/HistoricoPagamentos';
import Rastreamento from './pages/Rastreamento';
import FunemgEad from './pages/FunemgEad';

// "/" é a HOME: para quem está logado é o portal (Dashboard); para visitante é a
// landing pública. Assim o "início" do estudante logado mora em "/", e o Sair
// (que limpa a sessão e manda pra "/") cai naturalmente na landing.
function Home() {
    return isAuthenticated()
        ? <RequireAuth element={<Dashboard />} />
        : <Landing />;
}

const router = createBrowserRouter([
    {
        // Casca única do app: tema + toast + .ueb-portal. NotFound cobre erros.
        element: <AppLayout />,
        errorElement: <NotFound />,
        children: [
            // "/" é a HOME dupla: landing pública (visitante) OU portal (logado).
            { path: '/', element: <Home /> },

            // conta (público)
            { path: '/login', element: <Login /> },
            { path: '/registrar', element: <RegistrarUser /> },
            { path: '/recuperar-acesso', element: <RecuperarAcesso /> },
            { path: '/esqueci-senha', element: <EsqueciSenha /> },
            { path: '/redefinir-senha', element: <RedefinirSenha /> },
            { path: '/recuperar-conta', element: <RecuperarConta /> },
            { path: '/recuperar-conta/confirmar', element: <ConfirmarRecuperarConta /> },
            { path: '/confirmar-email', element: <ConfirmarEmail /> },
            { path: '/descadastrar-email', element: <DescadastrarEmail /> },

            // Validador público (QR da carteirinha). Param `codUso` bate com o
            // useParams() da página. A API usa currentServer (backend correto).
            { path: '/validador/:cpf/:codUso', element: <ValidadorUEB /> },

            // portal do estudante (privado). "/inicio" agora é a própria "/" —
            // mantém o caminho antigo funcionando via redirect (links salvos, etc.).
            { path: '/inicio', element: <Navigate to="/" replace /> },
            { path: '/produtos', element: <RequireAuth element={<Produtos />} /> },
            { path: '/minha-carteirinha', element: <RequireAuth element={<MinhaCarteirinha />} /> },
            { path: '/meu-historico', element: <RequireAuth element={<HistoricoPagamentos />} /> },
            { path: '/rastreamento', element: <RequireAuth element={<Rastreamento />} /> },
            { path: '/funemg', element: <RequireAuth element={<FunemgEad />} /> },

            { path: '*', element: <NotFound /> },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);
